<template>
  <VLayout>
    <VFlex xs12>
      <VCard style="height: calc(100vh - 100px)">
        <VLayout justify-space-around row>
          <VFlex xs6>
            <VCardTitle style="font-variant: small-caps">
              <h1>IBAN</h1>
              <v-spacer />
              <VBtn color="primary" :loading="loading" @click="syncPartnerIbans">
                Sinhroniziraj
              </VBtn>
            </VCardTitle>
            <VContainer class="pa-0" fill-height fluid>
              <VLayout fill-height>
                <v-flex>
                  <VDataTable
                    :headers="headers"
                    :items="partnerIbans"
                    rows-per-page-text="Vrstic na stran"
                  >
                    <template v-slot:items="props">
                      <td class="text-xs-center">{{ props.item.iban }}</td>
                      <td class="text-xs-center">{{ props.item.partner.name }}</td>
                      <td class="text-xs-center">{{ props.item.partner.vat_id }}</td>
                    </template>
                    <template slot="no-data"> Ni zadetkov :( </template>
                  </VDataTable>
                </v-flex>
              </VLayout>
            </VContainer>
          </VFlex>
        </VLayout>
      </VCard>
    </VFlex>
  </VLayout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'PartnerIbans',
  data() {
    return {
      headers: [
        {
          text: 'IBAN',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Ime partnerja',
          align: 'center',
          sortable: false,
        },
        {
          text: 'Davčna številka partnerja',
          align: 'center',
          sortable: false,
        },
      ],
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      partnerIbans: 'partnerIbans',
    }),
  },
  mounted() {
    this.$store.dispatch('setDrawerStateAction', true);
    this.getPartnerIbansAction();
  },
  methods: {
    ...mapActions(['setSnackBarStateAction', 'getPartnerIbansAction', 'syncPartnerIbansAction']),
    async syncPartnerIbans() {
      this.loading = true;
      try {
        await this.syncPartnerIbansAction();
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
::v-deep .v-table__overflow {
  overflow: auto;
  max-height: 70vh;
}
</style>
